import styled from 'styled-components';
import CarNumberTemplate from './CarNumberTemplate';

export const CarNumberStyled = styled(CarNumberTemplate)``;
